module.exports = __webpack_public_path__ + "static/media/hoc4.bdcf86e7.jpg";